import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class GetRequestUserGroupsModel extends RequestModel {
  constructor() {
    super(REQUEST.CATEGORY.groups, REQUEST.ACTION.GROUPS.getUserGroups, {}, false, true ,true, false);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.get;
  }
}
